import React from "react";
import { NavLink, Link } from "react-router-dom";
import { Navbar, NavDropdown } from "react-bootstrap";
import {
  loggedIn,
  logout,
  checkIfCustomer,
  initStudentPortal,
} from "../../services/auth";
import Dropdown from "react-bootstrap/Dropdown";
import logo from "../../logo.png"; // Import the image

const Nav = () => {
  const isLoggedIn = loggedIn();
  const isCustomer = checkIfCustomer();
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      sticky="top"
      className="navbar-container"
    >
      <Link className="navbar-brand" to="/">
        <img alt="" src={logo} className="img-fluid" />
      </Link>

      <Navbar.Toggle aria-controls="responsive-navbar-nav" />

      <div className="social-media">
        <Dropdown className="shareIcons">
          <Dropdown.Toggle id="socialdropdown">Follow Us</Dropdown.Toggle>

          <Dropdown.Menu>
            <ul>
              <li>
                <a
                  className="nav-item nav-link text-uppercase"
                  href="https://facebook.com/vocalresults"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-facebook"></i>
                </a>
              </li>

              <li>
                <a
                  className="nav-item nav-link text-uppercase"
                  href="https://instagram.com/vocalresults"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-instagram"></i>
                </a>
              </li>
              <li>
                <a
                  className="nav-item nav-link text-uppercase "
                  href="https://www.youtube.com/channel/UCEth5jqqnHAqx7eGby8YLKQ/videos"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-youtube"></i>
                </a>
              </li>
              <li>
                <a
                  className="nav-item nav-link text-uppercase"
                  href="https://www.tiktok.com/@vocalresults"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-icon="tiktok"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="currentColor"
                      d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <p className="nav-item nav-link text-uppercase mb-0 fs1_3 nav-text">
        Vocal Results Studio®
      </p>

      <Navbar.Collapse
        id="responsive-navbar-nav"
        className="flex-grow-0 nav-links"
      >
        <a
          className="nav-item nav-link text-uppercase"
          href="https://www.vocalresults.com/join"
          target="_blank"
          rel="noreferrer"
        >
          Find a vocal coach
        </a>

        <a
          className="nav-item nav-link text-uppercase"
          href="https://anchor.fm/vocalresults/episodes/Welcome-to-The-Ultimate-Vocal-Routine-eq54ph"
          target="_blank"
          rel="noreferrer"
        >
          Audio Exercises
        </a>

        <a
          className="nav-item nav-link text-uppercase"
          href="mailto:info@vocalresults.com?subject=Contact Vocal Results"
        >
          Contact
        </a>

        {!isLoggedIn && (
          <React.Fragment>
            <NavLink
              className="nav-item nav-link text-uppercase"
              to="/login"
              style={({ isActive }) => ({
                color: isActive ? "red" : "black",
              })}
              // onClick={(e) => {
              //   e.preventDefault();
              //   window.location.href = "/login";
              // }}
            >
              Sign In
            </NavLink>

            <NavLink
              className="nav-item nav-link text-uppercase register"
              to="/register"
              style={({ isActive }) => ({
                color: isActive ? "red" : "black",
              })}
              // onClick={(e) => {
              //   e.preventDefault();
              //   window.location.href = "/register";
              // }}
            >
              Sign Up
            </NavLink>
          </React.Fragment>
        )}

        {isLoggedIn && (
          <NavDropdown
            title={
              <div className="pull-left">
                <i className="fa fa-2x fa-user-circle"></i>
              </div>
            }
            id="nav-dropdown"
          >
            {isCustomer && (
              <React.Fragment>
                <NavLink
                  to="/portal"
                  className="nav-item text-uppercase dropdown-item"
                  onClick={(event) => {
                    event.preventDefault();
                    initStudentPortal();
                  }}
                  style={({ isActive }) => ({
                    color: isActive ? "red" : "white",
                  })}
                >
                  Student Portal
                </NavLink>
                <NavDropdown.Divider />
              </React.Fragment>
            )}

            <NavDropdown.Item
              className="text-uppercase logout"
              onClick={(event) => {
                event.preventDefault();
                logout();
              }}
            >
              Logout
            </NavDropdown.Item>
          </NavDropdown>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Nav;
